module.exports = __webpack_public_path__ + "img/to-your-health-logo.5d1f4f0e.jpg";